import { getGlobalThis } from "../utils.js";
import { KeyValueStore } from "./key-value-store.js";
const _UniversalMemoryStorage = class _UniversalMemoryStorage2 {
  constructor(id) {
    this.id = id;
    this.globalStore = new KeyValueStore();
  }
  static getOrCreate(id) {
    const global = getGlobalThis();
    const storageSymbol = Symbol.for(`${_UniversalMemoryStorage2.ID}-${id}`);
    let storage = global[storageSymbol];
    if (!storage) {
      storage = new _UniversalMemoryStorage2(id);
      global[storageSymbol] = storage;
    }
    return storage;
  }
  getStore() {
    if (!this.asyncStorage) {
      return this.globalStore;
    }
    const asyncStore = this.asyncStorage.getStore();
    if (asyncStore) {
      return asyncStore;
    }
    throw new Error(`UniversalMemoryStorage: 'AsyncLocalStorage' is invalid.`);
  }
  useAsyncLocalStorage(storage) {
    this.asyncStorage = storage;
  }
  switchBackToGlobalStore() {
    delete this.asyncStorage;
  }
  isUsingAsyncStorage() {
    return !!this.asyncStorage;
  }
  get(key) {
    const store = this.getStore();
    return store.get(key);
  }
  has(key) {
    const store = this.getStore();
    return typeof store.get(key) !== "undefined";
  }
  set(key, value) {
    const store = this.getStore();
    store.set(key, value);
  }
  remove(key) {
    const store = this.getStore();
    store.remove(key);
  }
};
_UniversalMemoryStorage.ID = "crystal-universal-storage";
let UniversalMemoryStorage = _UniversalMemoryStorage;
export {
  UniversalMemoryStorage
};
//# sourceMappingURL=universal-memory-storage.js.map
